<template>
	<div>
		<!-- <top></top> -->
		<div class="policy">
			<div class="flex align-center justify-between padding-sm bg-white margin-tb">
				<!-- <p class="text-sm text-666">首页 - 政策解读</p>
				<p class="flex align-center text-999 text-sm pointer" @click="back()">
					<i class="el-icon-back"></i>
					<span>返回</span>
				</p> -->
				<el-breadcrumb separator-class="el-icon-minus">
				  <el-breadcrumb-item :to="{ path: '/' }"><span class="text-sm text-666">首页</span></el-breadcrumb-item>
				  <el-breadcrumb-item><span class="text-sm text-666">政策解读</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div v-if="total != 0">
				<div class="flex justify-between bg-white padding-lr-sm padding-tb margin-bottom cursor" v-for="(item,index) in list" :key="index" @click="godetail(item)">
					<div class="margin-top">
						<p class="title text-bold">{{item.title}}</p>
						<p class="flex align-center margin-top-sm">
							<img v-if="item.status == 1" class="hot" src="../../assets/img/hot.png" >
							<span class="text-666 text-df margin-left-xs">{{item.create_time}}</span>
						</p>
					</div>
					<img class="hotimg" :src="item.logo" >
				</div>
				<div class="pagination">
					<el-pagination
					  @current-change="handleCurrentChange"
					    background
					    layout="prev, pager, next"
					    prev-text="上一页"
					    next-text="下一页"
					    :total="total">
					</el-pagination>
				</div>
			</div>
			<div class="text-center" v-else>
				<el-empty description="暂无数据"></el-empty>
			</div>
			<el-backtop :bottom="100">
			    <div class="backtop flex align-center justify-center flex-direction">
					<img class="up" src="../../assets/img/up.png" >
					<p class="toptitle">回顶部</p>
			    </div>
			</el-backtop>
		</div>
		<router-view />
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	import Top from '@/components/public/top.vue';
	export default {
		components: {
			Top,
		},
		name: '',
		data() {
			return {
				page:1,
				list:[],
				total:0,//
			}
		},
		created() {
			//通知听不状态栏 选中的页面
			Bus.$emit('chosename','home')
			this.getList()
		},
		methods: {
			back(){
				this.$router.back()
			},
			getList(){
				this.ajax('get', '/api/policy/getList', {
					page:this.page,
				}, res => {
					if(res.status == 200){
						this.list = res.data.data
						if(this.page == 1){
							this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
						}
					}
				})
			},
			handleCurrentChange: function(currentPage) {
			  this.page = currentPage;
			  this.getList();
			},
			godetail(data){
				this.$router.push({
					name:'pdetail',
					query: {
						id:data.id
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.policy{
		width: 1210px;
		margin: 0 auto;
		.title{
			font-size: 24px;
		}
		.hot{
			width: 27px;
			height: 23px;
		}
		.hotimg{
			width: 224px;
			height: 146px;
		}
	}
	.up{
		width: 21px;
		height: 23px;
	}
	/deep/ .el-backtop{
		width: 91px;
		height: 91px;
	}
	.backtop{
		width: 91px;
		height: 91px;
		background: #FFFFFF;
		box-shadow: 0px 5px 29px 2px rgba(239,236,236,0.1000);
		border-radius: 50%;
		.toptitle{
			color: #333;
			font-size: 14px;
			margin-top: 8px;
		}
	}
	/deep/ .el-pagination.is-background .btn-next,/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .el-pager li{
		background: #fff !important;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
		background:#09827B !important;
		color: #fff !important;
	}
	/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .btn-next{
		padding: 0 10px;
	}
	
	.pagination{
		margin: 59px 0;
	}
	
</style>



// WEBPACK FOOTER //
// src/view/index/policy.vue